import { Directive, ElementRef, Renderer2 } from '@angular/core';

import type { ArrowPosition } from './types';

const arrowSizePx = 16;
const distanceFromElement = 8;
const padding = arrowSizePx + distanceFromElement;

@Directive({ standalone: true })
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export class BaseTooltipComponent {
  public arrowPosition: ArrowPosition;
  public dynamicPadding: Record<NonNullable<ArrowPosition>, Partial<CSSStyleDeclaration>> = {
    top: { paddingTop: `${padding}px` },
    topleft: { paddingLeft: `${padding}px` },
    lefttop: { paddingTop: `${padding}px` },
    righttop: { paddingTop: `${padding}px` },
    left: { paddingLeft: `${padding}px` },
    right: { paddingRight: `${padding}px` },
    bottom: { paddingBottom: `${padding}px` },
    leftbottom: { paddingBottom: `${padding}px` },
    rightbottom: { paddingBottom: `${padding}px` },
    bottomleft: { paddingLeft: `${padding}px` },
  };

  constructor(
    protected elementRef: ElementRef,
    protected renderer2: Renderer2,
  ) {}

  public updateArrow(arrowPosition: ArrowPosition): void {
    this.arrowPosition = arrowPosition;
    if (arrowPosition) {
      this.clearHostPadding();
      this.addPadding(arrowPosition);
    }
  }

  private clearHostPadding(): void {
    Object.keys(
      Object.values(this.dynamicPadding).reduce((acc, styles) => ({ ...acc, ...styles }), {}),
    ).forEach(key => this.renderer2.removeStyle(this.elementRef.nativeElement, key));
  }

  private addPadding(arrowPosition: NonNullable<ArrowPosition>): void {
    Object.entries(this.dynamicPadding[arrowPosition]).forEach(([style, value]) => {
      this.renderer2.setStyle(this.elementRef.nativeElement, style, value);
    });
  }
}
